<template>
<v-app v-bind:class="{ xsOnly: $vuetify.breakpoint.xsOnly, smAndUp: $vuetify.breakpoint.smAndUp, mdAndUp: $vuetify.breakpoint.mdAndUp  }">
        <div v-if="error" style="">
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour" style="width:100%;"></app-alert>
        </div>
    <v-layout v-show="isLoading"
      align-center
      justify-space-around
      wrap
      fill-height
      style="background:var(--background-grey);"
      >
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50">
      </v-progress-circular>
    </v-layout>
    <div class="loaded-page" v-show="!isLoading">
    <transition name="fade" >
    <div v-if="invoice.status !== 'Paid'" class="announce-bar text-xs-center">
      <span>
        Hi&nbsp;<strong>{{customerName}}</strong>, your invoice from&nbsp;<strong>{{invoice.groupTitle}}</strong>&nbsp;is ready for payment.
      </span>
    </div>
    </transition>
    <transition name="fade" >
    <div v-if="invoice.status === 'Paid'" class="announce-bar paid text-xs-center">
      <span >
        Thank you for your payment for invoice {{invoice.invoice_ref}}.
      </span>
    </div>
    </transition>
    <div class="header-area mt-5">
      <div class="header-info">
        <span v-if="invoice.status !== 'Paid'" class="body-1 d-block pr-3">Amount due:</span>
        <span v-else class="body-1 d-block pr-3">You paid:</span>
        <span class="headline">{{invoice.amount | toCurrency(invoice.lang, invoice.currCode)}}</span>
        <a :href='downloadLink'><download-icon class="downloadpdf ml-4" style="fill:#000"></download-icon></a>
        <div v-if="invoice.payable && invoice.status !== 'Paid'" >
          <v-btn  color="primary" block depressed @click="showPay = !showPay" class="body-2 mt-3" style="height:50px;"><lock-icon class="mr-1 downloadpdf" style="fill:#fff"></lock-icon>Pay securely online now</v-btn>
        </div>
      </div>
      <div class="payment-area">
        <div v-if="invoice.payable && invoice.status !== 'Paid'" >
          <transition name="fade">
            <div v-show="showPay" class="mt-2" :class="{ 'mb-4': $vuetify.breakpoint.xsOnly, 'mb-4': !$vuetify.breakpoint.xsOnly }">
                <card
                  v-if="isPayReady"
                  ref="stripeCard"
                  class='stripe-card'
                  :class='{ complete }'
                  :stripe='stripe_key'
                  :options='stripeOptions'
                  @change='complete = $event.complete'
                  />
                <v-btn color="accent" block large depressed class='pay-with-stripe' type="submit" :disabled='!complete' :loading="isLoading" @click='pay'>
                  Pay {{invoice.amount | toCurrency(invoice.lang, invoice.currCode)}}
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </v-btn>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="invoice-preview mt-5">
      <invoice-preview
        :invoice="invoice"
        :imageUrl="invoice.logo"
        :invoicedDateFormatted="this.formatDate(invoice.invoiced_date)"
        ></invoice-preview>
    </div>

    <p class="body-small text-xs-center mt-3">
          This invoice was generated for you by {{invoice.groupTitle}} using <a href="https://tryworktabs.com" target="blank">tryworktabs.com</a>
    </p>

    </div>

</v-app>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import { formatDate } from '@/components/Mixins/formatDate'
import InvoicePreview from '@/components/Invoice/InvoicePreview'
import { Card, instance as StripeInstance } from 'vue-stripe-elements-plus'
import DownloadIcon from '@/components/Shared/DownloadIcon'
import LockIcon from '@/components/Shared/LockIcon'

export default {
  name: 'invoice',
  components: {
    InvoicePreview,
    Card,
    DownloadIcon,
    LockIcon
  },
  mixins: [formatDate],
  data () {
    return {
      showPay: false,
      itemId: this.$route.params.invoice_id,
      groupId: this.$route.params.group_id,
      customerEmail: this.$route.query.e || '',
      customerName: this.$route.query.e || '',
      complete: false,
      stripeOptions: {
      // see https://stripe.com/docs/stripe.js#element-options for details
        hidePostalCode: true
      },
      stripe_key: '',
      clientSecret: '',
      invoice: {
        id: '',
        title: '',
        clientName: '',
        amount: '',
        contact: '',
        invoice_ref: '',
        invoiced_date: '',
        paid_date: '',
        chargeTax: false,
        taxRate: '',
        clientAddress: '',
        postCode: '',
        groupTitle: '',
        groupAddress: '',
        logo: '',
        logoWidth: 120,
        logoAlign: 'center',
        paymentTerms: '',
        totalNet: 0,
        totalTax: 0,
        totalGross: 0,
        lineItems: [],
        status: 'Sent',
        payable: false
      },
      site_url: process.env.VUE_APP_SITEURI,
      loading: 0,
      error: null
    }
  },
  computed: {
    isPayReady () {
      if (this.stripe_key.length > 1) {
        return true
      } else {
        return false
      }
    },
    isLoading () {
      if (this.loading > 0) {
        return true
      } else {
        return false
      }
    },
    downloadLink () {
      const cb = Date.now()
      return `${this.site_url}/html2pdf?g=${this.groupId}&i=${this.invoice.id}&n=${this.invoice.invoice_ref}&c=${cb}`
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    addLoading () {
      this.loading++
    },
    subtractLoading () {
      this.loading--
    },
    async fetchData () {
      // check for existing invoice, if so grab all items from this
      try {
        this.addLoading()
        const getCustomerInvoice = firebase.functions().httpsCallable('getCustomerInvoice')
        const response = await getCustomerInvoice({ groupId: this.$route.params.group_id, invoiceId: this.$route.params.invoice_id })
        this.invoice = response.data
        this.subtractLoading()
      } catch (error) {
        this.error = error
        this.subtractLoading()
      }
    },
    async logRead () {
      this.addLoading()
      const readMsg = {
        created: Date.now(),
        status: 'Opened',
        by: this.customerEmail

      }
      try {
        const addInvoiceActivity = firebase.functions().httpsCallable('addInvoiceActivity')
        await addInvoiceActivity({ groupId: this.$route.params.group_id, invoiceId: this.$route.params.invoice_id, payload: readMsg })
        this.subtractLoading()
      } catch (error) {
        this.error = error
        this.subtractLoading()
      }
    },
    async getPaymentIntent () {
      this.addLoading()
      try {
        const getIntentSecret = firebase.functions().httpsCallable('getIntentSecret')
        const getIntentSecretObj = await getIntentSecret({ groupId: this.$route.params.group_id, invoiceId: this.$route.params.invoice_id })
        if (getIntentSecretObj.data.status === 'success') {
          this.clientSecret = getIntentSecretObj.data.client_secret
          this.stripe_key = getIntentSecretObj.data.stripe_publishable_key
        }
        this.subtractLoading()
      } catch (error) {
        this.error = error
        this.subtractLoading()
      }
    },
    async pay () {
      this.addLoading()
      const thisCard = this.$refs.stripeCard.$refs.element._element

      StripeInstance.confirmCardPayment(this.clientSecret, {
        payment_method: {
          card: thisCard,
          billing_details: {
            email: this.customerEmail
          }
        }
      }).then(async result => {
        console.log(result)
        if (result.error) {
          // Show error to your customer (e.g., insufficient funds)
          console.log(result.error.message)
          this.error = result.error
          this.subtractLoading()
        } else {
          // The payment has been processed!
          if (result.paymentIntent.status === 'succeeded') {
            // Show a success message to your customer
            // There's a risk of the customer closing the window before callback
            // execution. Set up a webhook or plugin to listen for the
            // payment_intent.succeeded event that handles any business critical
            // post-payment actions.
            console.log(result.paymentIntent)
            console.log('it worked')
            this.invoice.status = 'Paid'
            this.subtractLoading()
          }
        }
      })
    }
  },
  created () {
    this.fetchData()
    this.getPaymentIntent()
    this.logRead()
  }
}
</script>

<style lang="scss">
.announce-bar{
  display:flex;
  justify-content: center;
  padding:20px;
  background:blue;
  color:#fff;
  background: linear-gradient(to right, #265698, #248fd5);
  position:absolute;
  top:0;
  left:0%;
  width:100%;
  &.paid{
    background: linear-gradient(to right, #729b3d, #8fd330);
  }
}
.header-area{
  padding-top:55px;
   display:block;
    max-width:95%;
    width:95%;
    margin:0 auto;
    text-align: center;
    .smAndUp & {
      width:66.6666666666666%;
      max-width:66.6666666666666%;

    }
  .mdAndUp &{
    text-align:left;
    display:flex;
    justify-content: space-between;
    align-items:center;
  }
}
.header-info{
  margin-bottom:20px;
  text-align:left;
  display:inline-block;
  margin: 0 auto 20px 0;
  width:100%;
  .mdAndUp &{
    margin-bottom:0px;
    width:50%;
  }
}
.payment-area{
  margin-top: 12px;
    display: inline-block;
    width: 100%;
    .mdAndUp &{
    margin-bottom:0px;
    width:48%;
  }
}
.invoice-preview{
  max-width:95%;
    width:95%;
  margin:0 auto;
  .mdAndUp &{
    max-width:1000px;
    width:45vw;
  }
}
.downloadpdf{
  color:#fff;
  fill: #fff;
}
.downloadpdf:hover{
  // background:var(--light-text);
}
h1{
  width:100%;
  display:block;
}
.pay-with-stripe {
  margin-bottom:0;
  margin-top:10px;
}
.stripe-card {
  max-width: 423px;
  width:100%;
  max-width:100%;
  border: 1px solid rgb(212, 210, 210);
  background:#fff;
  border-radius:3px;
  padding:13px 35px;
  font-size:1.1em;
}
.stripe-card.complete {
  border-color: green;
}
.btn:not(.btn--flat){
  box-shadow: inset 0 0 0 1px rgba(0, 0, 20, 0.1);
  text-transform:capitalize;
  font-weight:700;
  margin: 10px 0px 6px 8px;
  &.accent{
    background-image: linear-gradient(var(--button-gradient-start-green), var(--green));
  }
  &.error{
    background: var(--red);
  }
}
.customerpaidstamp{
  position:absolute;
  top:25%;
  right:20%;
  width:300px;
  z-index:1;
  img{
    max-width:100%;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
